import { TeamPanel as TeamPanelComponent } from './TeamPanel.component';
import { connector } from './TeamPanel.connector';

export const TeamPanel = connector((TeamPanelComponent))
